import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faRedo }  from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-modal-reload-app',
  templateUrl: './modal-reload-app.component.html',
styleUrls:  ['./modal-reload-app.component.css']
})
export class ModalReloadAppComponent implements OnInit {
	faRedo = faRedo;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  handleReload(): void {
    // Bundles are content-hashed (outputHashing: 'all'), so a new deploy
    // changes the filenames index.html references — a plain reload fetches
    // the fresh bundles and can't serve a stale one.
    window.location.reload();
  }

}
